<template>
  <div id="accordion" class="w-100 card p-3">
       <Modal :name="'emailActivity'+clientId" class="m-4">
        <div v-for="email in emails" class="card p-2" >
         
            <span>  <span class="mr-2"><i class="icon-circle" :class="getStatusColor(email.campaign_step_business_contact_status_id)"></i> {{getStatus(email.campaign_step_business_contact_status_id)}}</span><span v-html="email.subject" class="mr-2"></span> <span class="text-secondary mr-2">{{email.email_sent}}</span>  <i class="icon-user text-primary"></i> <input  class="mx-2" :value="email.email_from" disabled></input> <i class="icon-arrow-right mr-2 text-primary"></i> <i class="icon-user text-primary"></i> <input class="ml-2" :value="email.email_to" disabled></input>

            <span  :class="getColor(email.step)">Step {{email.step}}</span>
            <span class="badge badge-light text-primary" v-if="email.cant > 0"><i class="icon-eye"></i><i class="icon-calendar"></i> {{email.cant}}</span>
            </span>

        </div>


       </Modal>
  <div class="ml-1">
      <div>
        <small><i class="icon-circle text-secondary "></i></small><small><strong class="ml-1">1 emails x 2 minute x campaign</strong> </small>  
      </div>
      <div>
          <small><i class="icon-circle text-secondary "></i> <small class="ml-1 badge badge-secondary">
         <i class="icon-warning text-warning" ></i> <strong>TF</strong> Target Finished</small> = <i class="icon-stop text-danger ml-2"></i> Target not closed AND <i class="icon-group text-primary"></i> Contacts imported from apollo (not the same as used) > 90%</small>
      </div> 

        </div>

        <div>
         <small class="ml-1"><i class="icon-circle text-success"></i> sent</small> 
        <small class="ml-1"><i class="icon-circle text-primary"></i> scheduled</small> 
        <small class="ml-1"><i class="icon-circle text-warning"></i> estimated</small> 
        <small class="ml-1"><i class="icon-circle text-secondary"></i> canceled</small>  
        <small class="ml-1"><i class="icon-circle text-danger"></i> bounced</small> 
        <small class="ml-1"><i class="icon-flag text-danger"></i> limit reached</small>
        </div>
         
  <div class="card p-2 mt-2">
    <span class="loadingres spinner-border loading-spinner ml-2" v-if="campaigns.length == 0"></span>
    <div v-else>
      <div class="mb-1">
        <span @click="thisweek=2;loadstats()" class="badge cursor-pointer  text-white " :class="thisweek != 2 ? 'badge-secondary' : 'badge-primary'">Yesterday</span> 
        <span @click="thisweek=0;loadstats()" class="badge cursor-pointer  text-white ml-1" :class="thisweek != 0 ? 'badge-secondary' : 'badge-primary'">Today</span> 
        <span @click="thisweek=1;loadstats()" class="badge cursor-pointer badge-primary text-white ml-1" :class="thisweek != 1 ? 'badge-secondary' : 'badge-primary'">Week</span> 
        <span @click="loadstats()" class="badge cursor-pointer badge-light text-white ml-1" :class="thisweek != 1 ? 'badge-secondary' : 'badge-primary'">  <i class="icon-refresh text-primary" ></i></span>  
      </div>

    <div v-for="(item,user_id) in campaigns" class="my-1" @click="showEmails(item.user_id)">
      <div>
         <small  v-if="item.available_contacts == 0 && item.open && getPercentageUsed(item) > 90" class="badge badge-secondary mr-1">
         <i class="icon-warning text-warning" ></i> <strong>TF</strong></small>

         <small ><span class="">
         <small > id: {{item.id}} <a target="_blank" :href="'/campaigns/'+item.id" class="text-primary"><span class="mx-1">{{item.name}}</span></a> </small>  {{item.diffdays}} days - {{item.available_contacts}} a.c <span v-if="item.open == 0"><i class="icon-stop text-danger"></i></span></span> </small>  
         
        <small class="" v-if="item.apollo_used_contacts"> - <i class="icon-group text-primary"></i> {{item.apollo_used_contacts}}/{{ item.apollo_total_contacts }} ({{getPercentageUsed(item)}}%)</small>

        <span v-if="item.account_paused == 1" class="badge badge-light text-danger"><i class="icon-flag"></i></span>
        <span class="badge badge-light text-secondary"><i class="icon-eye"></i><i class="icon-calendar"></i> {{item.clicks}}</span>
        <span class="badge badge-success text-white"><i class="icon-email"></i> {{item.sent}}</span>=<span class="badge badge-success text-white">{{item.sent_1}}/{{item.sent_s1}}</span>+<span class="badge badge-success text-white" style="opacity:0.8">{{item.sent_2}}/{{item.sent_s2}}</span>+<span class="badge badge-success text-white" style="opacity:0.7">{{item.sent_3}}/{{item.sent_s3}}</span>+<span class="badge badge-success text-white" style="opacity:0.6">{{item.sent_4}}/{{item.sent_s4}}</span>+<span class="badge badge-success text-white" style="opacity:0.5">{{item.sent_5}}/{{item.sent_s5}}</span>+<span class="badge badge-success text-white" style="opacity:0.4">{{item.sent_6}}/{{item.sent_s6}}</span> |
        <span class="badge badge-primary text-white" v-if="item.scheduled > 0"><i class="icon-clock"></i> {{item.scheduled}}</span> 
        <span class="badge badge-warning text-white" v-if="item.estimated > 0"><i class="icon-question"></i>  {{item.estimated}}</span> 
        <span class="badge badge-secondary text-white" v-if="item.canceled > 0"><i class="icon-stop"></i> {{item.canceled}}</span>  
        <span class="badge badge-danger text-white" v-if="item.bounced > 0"><i class="icon-close"></i> {{item.bounced}}</span> 
        <small class="ml-2 badge badge-secondary text-white" v-if="false">{{getDateSplit(item.first_email_sent)}} </small> 
         <small class="badge badge-white text-secondary mx-2">{{getDateSplit(item.last_email_sent)}}   </small>
       </div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>

import Vue from "vue";
import { clientsService, usersService } from "@/_services";
import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";
import Modal from "@/components/Common/Modal.vue";



export default {
  data () {
    return {
      campaigns:[],
      emails:[],
      thisweek:0
    }
  }, 
  
  props: {
    clientId:String
  },  

  components: { ItemMonitor,Modal },


  created() {
    this.loadstats();
  },
  methods:{
      getPercentageUsed(item){
        return Math.round((item.apollo_used_contacts * 100 / item.apollo_total_contacts))
      },
      showEmails(user_id){
        this.emails = []
        clientsService.getEmailActivity(user_id).then((responseCampaign) => {
            this.emails = responseCampaign
            this.$modal.show('emailActivity'+this.clientId)
        })
        
      },
       getStatus(status_id){
         if(status_id == 1){
            return "Scheduled"
         }  
         if(status_id == 2){
            return "Sent"
         } 
         if(status_id == 3){
            return "Bounced"
         } 
         if(status_id == 4){
            return "Canceled"
         } 
         if(status_id == 5){
            return "Estimated"
         } 
       },
       getStatusColor(status_id){
         if(status_id == 1){
            return "text-primary"
         }  
         if(status_id == 2){
            return "text-success"
         } 
         if(status_id == 3){
            return "text-danger"
         } 
         if(status_id == 4){
            return "text-secondary"
         } 
         if(status_id == 5){
            return "text-warning"
         } 
       },
      getColor(step){
        if(step == 1){
         return "badge badge-success text-white";
        }
        if(step == 2){
         return "badge badge-warning text-white";
        }
        if(step == 3){
         return "badge badge-secondary text-white";
        }
         return "badge badge-secondary text-white";
      
      },
      loadstats(){
        this.campaigns = []
        clientsService.getClientActivity(this.clientId,this.thisweek).then((responseCampaign) => {
            this.campaigns = responseCampaign
          
        })
      },
      getDateSplit(datestime){
        return datestime.split(" ")[1]
      }
  }
  
};
</script>